import { QUESTION_STATUS, WAGER_STATUS } from '@/constants/marketBackendEnums'

function isSold(bet, question) {
  if (bet) {
    return bet && bet.status === WAGER_STATUS.SALE
  }

  if (question) {
    return question.wagers && question.wagers.length > 0 && question.wagers[0].status === WAGER_STATUS.SALE
  }
}

function isDisabled(bet) {
  return bet && bet.status === WAGER_STATUS.DISABLE
}

function isBought(bet) {
  return bet && bet.status === WAGER_STATUS.PURCHASE
}

function isTradable(bet, question) {
  return (
    question.status === QUESTION_STATUS.OPEN &&
    bet &&
    bet.status === WAGER_STATUS.PURCHASE &&
    (question.bet_end_date === null || new Date(question.bet_end_date).getTime() > new Date().getTime())
  )
}

function isWinner(bet) {
  return bet && bet.status === WAGER_STATUS.WIN
}

function isLoser(bet) {
  return bet && bet.status === WAGER_STATUS.LOSE
}

export const BetRuleService = Object.freeze({
  isSold,
  isBought,
  isTradable,
  isWinner,
  isLoser,
  isDisabled,
})
